import { call, takeEvery, select, put, all, SelectEffect } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { createAdDivs, loadAndDisplayAds } from 'lib/GoogleAds/SuggestiveSellingAds';
import State, { Slot } from 'types/State';
import * as _ from 'lodash-es';
import {
  suggestiveSellingComponentTearingDown,
  slotNoLongerHasComponent,
  suggestiveSellingAdDisplayEnqueued,
  suggestiveSellingAdDivsCreated,
} from './googleAds';

function getRenderedSlots(): SelectEffect {
  return select((state: State) => _.pickBy(state.ads.slots, 'isSuggestive'));
}

function* teardown(): SagaIterator {
  const renderedSlots: Slot[] = yield getRenderedSlots();

  const destructions = _.map(renderedSlots, 'elementId').map((elementId) => {
    return put(slotNoLongerHasComponent({ elementId }));
  });

  yield all(destructions);
}

export default function* suggestiveSellingAdsSaga(): SagaIterator {
  yield takeEvery(suggestiveSellingComponentTearingDown, teardown);
  yield call(createAdDivs);
  yield put(suggestiveSellingAdDivsCreated());

  const adUnitPath: string = yield select((state: State) => state.ads.adUnit);

  yield call(loadAndDisplayAds, adUnitPath);
  yield put(suggestiveSellingAdDisplayEnqueued());
}
